import PropTypes from 'prop-types'
import React from 'react'
import SidebarRow from './BoardList/SidebarRow'
import SidebarRowComponent from './BoardList/SidebarRow/SidebarRow'
import styled from 'react-emotion'
import { color } from '../../style'

export const SidebarBreadcrumbs = styled(
  ({ folders, boardActive, className }) =>
    folders ? (
      <div className={className}>
        {folders.map((folder, i) => (
          <SidebarRow
            key={folder.id}
            selected={!boardActive && i === folders.length - 1}
            grey={!boardActive}
            item={folder}
          />
        ))}
      </div>
    ) : null
)({
  label: 'SidebarBreadcrumbs',
  borderBottom: `1px solid ${color.greyLine}`,
  [SidebarRowComponent]: {
    position: 'relative',
    '&:not(:last-child):after': {
      // vertical dash between folders
      content: '""',
      background: '#DBDBDB',
      position: 'absolute',
      top: 24,
      left: 14,
      width: 2,
      height: 12,
      zIndex:1
    }
  }
})

SidebarBreadcrumbs.propTypes = {
  folders: PropTypes.array
}

export default SidebarBreadcrumbs
